'use client'

import Box from '@mui/material/Box'

import BusinessSpendForm from '@/components/BusinessSpendForm'
import { HUBSPOT_FORM_IDS } from '@/utills/constants'

export default function Page() {
    return (
        <Box
            pt={{
                xs: 0,
                sm: 0,
                md: 9,
                lg: 9,
                xl: 9,
            }}
        >
            <BusinessSpendForm hubspotFormId={HUBSPOT_FORM_IDS.businessSpend} />
        </Box>
    )
}
